/**
 * Regras para mídia de produto (cn_media: IMG, VID, PDF).
 * Capa / grade: apenas IMG; ignora PDF/VID; exclui paths com "nutri".
 */

export type ProductMediaItem = {
  path: string
  format: string
}

const NUTRI_REGEX = /nutri/i

export function isNutriPath(path: string): boolean {
  return NUTRI_REGEX.test(path)
}

export function isEligibleCoverImage(m: ProductMediaItem): boolean {
  if (m.format !== 'IMG') return false
  if (isNutriPath(m.path)) return false
  return true
}

/** Primeira IMG elegível; se não houver, undefined (use fallback visual no componente). */
export function pickProductCoverImagePath(media: ProductMediaItem[] | null | undefined): string | undefined {
  if (!media?.length) return undefined
  return media.find(isEligibleCoverImage)?.path
}

export function pickProductGalleryImagePaths(media: ProductMediaItem[] | null | undefined): string[] {
  if (!media?.length) return []
  return media.filter(isEligibleCoverImage).map((m) => m.path)
}

export type DocumentTabResult = {
  url: string | undefined
  label: 'COA' | 'Informação Nutricional'
  show: boolean
}

const SUPPLEMENT_CLASS_ID = 6

/**
 * Suplementos (class 6): Informação Nutricional — primeiro arquivo com "nutri" no path; senão primeiro PDF; senão sem aba.
 * Demais classes: COA — primeiro PDF que não seja nutri; senão primeiro PDF; senão sem aba.
 */
export function pickDocumentTabForProduct(
  media: ProductMediaItem[] | null | undefined,
  classId: number | null | undefined
): DocumentTabResult {
  if (!media?.length) {
    return { url: undefined, label: 'COA', show: false }
  }

  const isSupplement = classId === SUPPLEMENT_CLASS_ID

  if (isSupplement) {
    const nutri = media.find((m) => isNutriPath(m.path))
    if (nutri) {
      return { url: nutri.path, label: 'Informação Nutricional', show: true }
    }
    const pdf = media.find((m) => m.format === 'PDF')
    if (pdf) {
      return { url: pdf.path, label: 'Informação Nutricional', show: true }
    }
    return { url: undefined, label: 'Informação Nutricional', show: false }
  }

  const coaPdf =
    media.find((m) => m.format === 'PDF' && !isNutriPath(m.path)) || media.find((m) => m.format === 'PDF')
  if (coaPdf) {
    return { url: coaPdf.path, label: 'COA', show: true }
  }
  return { url: undefined, label: 'COA', show: false }
}
